<template>
  <div class="mask" @touchmove.prevent>
    <div class="order_confirm_con">
      <div class="main_content mask_content">
        <div class="close_btn" @click="close"></div>
        <div class="pay_title bold">{{ $t('game.confirmOrder') }}</div>
        <div
          class="order-content"
          ref="orderContent"
          @scroll="handleScroll"
          v-loading="captureLoading"
          @touchmove.stop
          v-touchmove
        >
          <div class="flex-content pay_confirm_left">
            <!-- 玩家信息 -->
            <div class="module_con userInfo">
              <UserInfo :showInfo="userInfo" mode="pay" />
            </div>
            <!-- 商品详情 -->
            <div class="module_con pack_info">
              <p class="module_title regular">{{ $t('game.packageName') }}</p>
              <div class="module_content products-list">
                <ProductsItem :pack="pack" />
              </div>
            </div>
          </div>
          <!-- pay_confirm_right -->
          <div class="flex-content pay_confirm_right">
            <div class="module_con pay-postcode regular" v-if="isShowPostCode">
              <div class="txt">
                <span class="red" v-show="postcodeErrortext != ''">{{ postcodeErrortext }}</span>
                <span v-show="postcodeErrortext == ''">
                  {{ userIpCountry === 'US' ? $t('primer.usaCode') : $t('primer.caCode') }}
                </span>
                <span class="red"> *</span>
              </div>
              <div class="code-input-wrapper">
                <PostcodeInput
                  ref="postcodeInput"
                  :disabled="pay_submitis"
                  :type="userIpCountry"
                  :placeholder="userIpCountry === 'US' ? $t('primer.usaCode') : $t('primer.caCode')"
                  :postcode.sync="postcode"
                  :showValidation="true"
                  @validate="handlePostcodeValidate"
                />
              </div>
            </div>

            <!-- 支付选择框 -->
            <div class="module_con pays_con">
              <p class="module_title regular">{{ $t('game.paymentTitle') }}</p>
              <div class="module_content pay-list">
                <div
                  v-for="(item, index) in gateway"
                  :key="index"
                  :class="{
                    pay_item: true,
                    active: choosePayWay === item,
                  }"
                  ref="payItem"
                  @click="choosePay(item)"
                >
                  <template v-if="item == '75' || item == '83'">
                    <!-- {{ $t('payment.card') }} -->
                    <span>Card</span>
                    <img class="pay_icon" src="@img/payalert/card.png" alt="" />
                  </template>
                  <template v-if="item == '0'">
                    {{ $t('payment.paypal') }}
                    <img class="pay_icon pay_paypal" src="@img/payalert/paypal.png" alt="" />
                  </template>
                  <template v-if="item == '7501'">
                    <div class="kakaoitem">
                      {{ $t('paymentMethod.KakaoPay') }}
                      <img class="pay_icon" src="@img/payalert/kakao.png" alt="" />
                    </div>
                  </template>
                  <template v-if="item == '7502'">
                    <div class="kakaoitem">PayPay</div>
                    <img class="pay_icon pay_paypay" src="@img/payalert/paypay.svg" alt="" />
                  </template>
                  <template v-if="item == '8301'">
                    Apple Pay
                    <img class="pay_icon pay_apple" src="@img/payalert/apple.png" alt="" />
                  </template>
                  <template v-if="item == '8302'">
                    Google Pay
                    <img class="pay_icon pay_google" src="@img/payalert/google_new.png" alt="" />
                  </template>
                  <img
                    class="pay_choose_img"
                    v-show="choosePayWay === item"
                    src="@img/payalert/pay_active.png"
                  />
                </div>
              </div>
            </div>
            <!-- 支付选择框 -->

            <div class="legal-tips regular show-mobile" ref="legalTips">
              {{ $t('legalUS.terms') }}
              <a :href="$utils.getTermsOfServiceUrl($i18n.locale)" target="_blank">{{
                $t('legalUS.more')
              }}</a>
            </div>

            <!-- start 支付按钮 PC -->
            <div class="module_con pay_bottom" v-if="!isUIMobile">
              <!-- legal 条款 -->
              <div class="legal-tips regular show-pc">
                {{ $t('legalUS.terms') }}
                <a :href="$utils.getTermsOfServiceUrl($i18n.locale)" target="_blank">{{
                  $t('legalUS.more')
                }}</a>
              </div>

              <!-- 价格展示区 -->
              <div class="order-total regular" v-if="isProductionTax">
                <div class="tax-item">
                  <div class="tax-item-title">{{ $t('tax.prodPrice') }}</div>
                  <div class="number">
                    {{ taxInfo.currency_label }} {{ taxInfo.real_amount | formatPrice }}
                  </div>
                </div>
                <div class="tax-item">
                  <div class="tax-item-title">
                    {{ $t('tax.taxPrice') }}
                    <div
                      class="question-icon"
                      @click.stop="(_) => $root.Bus.$emit('showTooltips', _, $t('tax.howToGet'))"
                    ></div>
                  </div>
                  <div class="number">
                    <template v-if="taxInfo.tax">
                      {{ taxInfo.currency_label }} {{ taxInfo.tax | formatPrice }}
                    </template>
                    <template v-else> - </template>
                  </div>
                </div>
                <div class="tax-item total medium">
                  <div class="tax-item-title">{{ $t('tax.totalPrice') }}</div>
                  <div class="number">
                    {{ taxInfo.currency_label }} {{ taxInfo.taxed_price | formatPrice }}
                  </div>
                </div>
              </div>
              <div class="order-total" v-else>
                <div class="pay_bottom_total medium">
                  <span>{{ $t('game.total') }}: </span>
                  <span class="pay_price">{{ pack.package.currency_label + ' ' }}</span>
                  <span class="pay_price pay_price_big">
                    {{ totalPrice | formatPrice }}
                  </span>
                </div>
                <div class="pay_bottom_tips regular">
                  <span>{{ $t('game.taxTips') }}</span>
                </div>
              </div>

              <!-- 首充提示 -->
              <div class="purchase-tips regular" v-if="isShowFirstChargeTip">
                {{ $t('tips.firstChargeWelfare') }}
              </div>

              <!-- 限购提示 -->
              <div
                class="purchase-tips regular"
                v-if="pack.package && pack.package.purchase_count > 0"
              >
                {{ $t('pay.limitTips') }}
              </div>

              <div class="pay_btn">
                <div
                  class="btntp btn-mask isLoading"
                  v-show="pay_btn_style == 'render_loading' && !postcodeErrortext"
                ></div>
                <div class="btn disabled" v-show="isShowDisabledPayBtn">
                  {{ pack.package.currency_label }}
                  {{ totalPrice | formatPrice }}
                </div>
                <template v-if="!isShowDisabledPayBtn && updatePayComponent">
                  <div
                    class="btn"
                    :class="{ disabled: postcodeErrortext || !postcode }"
                    v-show="isCardPay"
                    @click="pay"
                  >
                    {{ pack.package.currency_label }}
                    {{ totalPrice | formatPrice }}
                  </div>
                  <!-- paypal 按钮 -->
                  <div
                    class="btntp paypal"
                    :class="{ isLoading: !postcodeErrortext }"
                    v-show="pay_btn_style == 'paypal'"
                  >
                    <Paypal
                      :paypalBtns="paypalBtns"
                      :payinfo="payinfo"
                      :pay_btn_style="pay_btn_style"
                    >
                    </Paypal>
                  </div>
                  <!-- 谷歌按钮态 -->
                  <div
                    class="btntp"
                    :class="{ isLoading: !postcodeErrortext, noPay: googlePayNoPay }"
                    v-show="pay_btn_style == 'google_pay'"
                  >
                    <PrimerOther
                      :payinfo="payinfo"
                      :pay_btn_style="pay_btn_style"
                      pay_style="google_pay"
                      @setPayNo="(flag) => (googlePayNoPay = flag)"
                    ></PrimerOther>
                  </div>

                  <!-- 苹果按钮态 -->
                  <div
                    class="btntp"
                    :class="{ isLoading: !postcodeErrortext, noPay: applePayNoPay }"
                    v-show="pay_btn_style == 'apple_pay'"
                  >
                    <PrimerOther
                      :payinfo="payinfo"
                      :pay_btn_style="pay_btn_style"
                      pay_style="apple_pay"
                      @setPayNo="(flag) => (applePayNoPay = flag)"
                    ></PrimerOther>
                  </div>

                  <!-- kakao按钮态 -->
                  <div
                    class="btntp"
                    :class="{ isLoading: !postcodeErrortext }"
                    v-show="pay_btn_style == 'kakao'"
                  >
                    <Kakao :payinfo="payinfo" :mount="mount" :pay_btn_style="pay_btn_style"></Kakao>
                  </div>
                  <!-- PayPay 按钮态 -->
                  <div
                    class="btntp"
                    :class="{ isLoading: !postcodeErrortext }"
                    v-show="pay_btn_style == 'paypay'"
                  >
                    <PayPay
                      :payinfo="payinfo"
                      :mount="mount"
                      :pay_btn_style="pay_btn_style"
                    ></PayPay>
                  </div>
                </template>
              </div>
            </div>
            <!-- end 支付按钮 PC -->
          </div>
          <!-- pay_confirm_right -->
        </div>

        <!-- start 支付按钮 移动端 -->
        <div class="module_con pay_bottom" v-if="isUIMobile">
          <!-- 限购提示 -->
          <div
            class="purchase-tips purchase-tips-2 regular"
            v-if="pack.package && pack.package.purchase_count > 0"
          >
            {{ $t('pay.limitTips') }}
          </div>

          <!-- 价格展示区 -->
          <div class="order-total regular" v-if="isProductionTax">
            <div class="tax-item">
              <div class="tax-item-title">{{ $t('tax.prodPrice') }}</div>
              <div class="number">
                {{ taxInfo.currency_label }} {{ taxInfo.real_amount | formatPrice }}
              </div>
            </div>
            <div class="tax-item">
              <div class="tax-item-title">
                {{ $t('tax.taxPrice') }}
                <div
                  class="question-icon"
                  @click.stop="(_) => $root.Bus.$emit('showTooltips', _, $t('tax.howToGet'))"
                ></div>
              </div>
              <div class="number">
                <template v-if="taxInfo.tax">
                  {{ taxInfo.currency_label }} {{ taxInfo.tax | formatPrice }}
                </template>
                <template v-else> - </template>
              </div>
            </div>
            <div class="tax-item total medium">
              <div class="tax-item-title">{{ $t('tax.totalPrice') }}</div>
              <div class="number">
                {{ taxInfo.currency_label }} {{ taxInfo.taxed_price | formatPrice }}
              </div>
            </div>
          </div>
          <div class="order-total" v-else>
            <div class="pay_bottom_total medium">
              <span>{{ $t('game.total') }}: </span>
              <span class="pay_price">{{ pack.package.currency_label + ' ' }}</span>
              <span class="pay_price pay_price_big">
                {{ totalPrice | formatPrice }}
              </span>
            </div>
            <div class="pay_bottom_tips regular">
              <span>{{ $t('game.taxTips') }}</span>
            </div>
          </div>

          <!-- 首充提示 -->
          <div class="purchase-tips regular" v-if="isShowFirstChargeTip">
            {{ $t('tips.firstChargeWelfare') }}
          </div>

          <!-- 支付按钮区 -->
          <div class="pay_btn">
            <div
              class="btntp btn-mask isLoading"
              v-show="pay_btn_style == 'render_loading' && !postcodeErrortext"
            ></div>
            <div class="btn disabled" v-show="isShowDisabledPayBtn">
              {{ pack.package.currency_label }}
              {{ totalPrice | formatPrice }}
            </div>
            <template v-if="!isShowDisabledPayBtn && updatePayComponent">
              <!-- 卡支付按钮 -->
              <div
                class="btn"
                :class="{ disabled: postcodeErrortext || !postcode }"
                v-show="isCardPay"
                @click="pay"
              >
                {{ pack.package.currency_label }}
                {{ totalPrice | formatPrice }}
              </div>
              <!-- paypal 按钮 -->
              <div
                class="btntp paypal"
                :class="{ isLoading: !postcodeErrortext }"
                v-show="pay_btn_style == 'paypal'"
              >
                <Paypal :paypalBtns="paypalBtns" :payinfo="payinfo" :pay_btn_style="pay_btn_style">
                </Paypal>
              </div>
              <!-- 谷歌按钮态 -->
              <div
                class="btntp"
                :class="{ isLoading: !postcodeErrortext, noPay: googlePayNoPay }"
                v-show="pay_btn_style == 'google_pay'"
              >
                <PrimerOther
                  :payinfo="payinfo"
                  :pay_btn_style="pay_btn_style"
                  pay_style="google_pay"
                  @setPayNo="(flag) => (googlePayNoPay = flag)"
                ></PrimerOther>
              </div>

              <!-- 苹果按钮态 -->
              <div
                class="btntp"
                :class="{ isLoading: !postcodeErrortext, noPay: applePayNoPay }"
                v-show="pay_btn_style == 'apple_pay'"
              >
                <PrimerOther
                  :payinfo="payinfo"
                  :pay_btn_style="pay_btn_style"
                  pay_style="apple_pay"
                  @setPayNo="(flag) => (applePayNoPay = flag)"
                ></PrimerOther>
              </div>

              <!-- kakao按钮态 -->
              <div
                class="btntp"
                :class="{ isLoading: !postcodeErrortext }"
                v-show="pay_btn_style == 'kakao'"
              >
                <Kakao :payinfo="payinfo" :mount="mount" :pay_btn_style="pay_btn_style"></Kakao>
              </div>
              <!-- PayPay 按钮态 -->
              <div
                class="btntp"
                :class="{ isLoading: !postcodeErrortext }"
                v-show="pay_btn_style == 'paypay'"
              >
                <PayPay :payinfo="payinfo" :mount="mount" :pay_btn_style="pay_btn_style"></PayPay>
              </div>
            </template>
          </div>
        </div>
        <!-- end 支付按钮 移动端 -->

        <transition name="pop-up">
          <div class="see-more" v-if="showSeeMore">
            <div class="text">
              {{ $t('paralert.seeMore') }}
            </div>
            <div class="see-more-btn"></div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import Paypal from '@/components/common/pay/paypal.vue'
import PrimerOther from '@/components/common/pay/primerOther.vue'
import Kakao from '@/components/common/pay/ayden.vue'
import PayPay from '@/components/common/pay/paypay.vue'

import UserInfo from './userCard/userInfo.vue'
import ProductsItem from './ProductsItem.vue'
import PostcodeInput from './form/PostcodeInput.vue'

import { checkCanPay, getProductionTax } from '@/api/index.js'
import { getCallPaymentLimitTrackingProps } from '@/tool/packagePurchaseLimit'
import { mapState, mapGetters } from 'vuex'
const googlePayFirstChannel = ['in_game', 'in_game_stage']
export default {
  props: ['pack', 'pay_info', 'mount', 'airwallex_deviceid', 'currency', 'last_gateway'],
  data() {
    return {
      choosePayWay: null,
      //目前支持的支付方式
      gateway: [],
      //是否支持苹果支付
      applepay_is: false,
      paysty: '',
      payinfo: {},
      //
      payment_log: null,
      //按钮样式
      pay_btn_style: 'card',
      //captureid 用于追踪结果
      captchaRequestId: '',
      //支付按钮是否点击
      pay_submitis: false,
      //是否可以切换goole和apple按钮
      apple_google_changeis: true,
      //用于缓存capture状态
      capture_status: '',

      // 是否显示更多付款方式提示
      showSeeMore: false,
      // 邮编
      postcode: '',
      postValidate: false,
      postcodeErrortext: '',
      // 邮编变化后需要重新渲染支付组件，通过这个变量控制组件展示
      updatePayComponent: true,
      captureLoading: false,
      // 谷歌支付按钮是否显示
      googlePayNoPay: false,
      // 苹果支付按钮是否显示
      applePayNoPay: false,
      // paypal paylater按钮是否显示
      paypalBtns: [],

      taxInfo: {
        real_amount: '',
        tax: '',
        taxed_price: '',
        currency: 'USD',
        currency_label: '$',
      },
      taxInfoSuccess: false,

      channel: this.$utils.customLocalStorage.getItem('dd_channel'),
    }
  },
  computed: {
    ...mapGetters(['isShowPostCode']),
    ...mapState({
      gameId: (state) => state.app.gameId,
      userInfo: (state) => state.user.userInfo,
      userIpCountry: (state) => state.user.userIpCountry,
      isUIMobile: (state) => state.app.isUIMobile,
      isMobile: (state) => state.app.isMobile,
      isProductionTax: (state) => state.app.isProductionTax,
    }),

    // 卡支付 - 需要点击按钮才下单
    // 非卡支付 - 直接下单，三方支付渲染付款按钮
    isCardPay() {
      return this.paysty === 'adyen' || this.paysty === 'primer'
    },

    isShowDisabledPayBtn() {
      let step1 = false
      let step2 = false
      // 是否需要邮编校验
      if (!this.isShowPostCode) {
        step1 = this.captureLoading
      } else {
        step1 = this.captureLoading || !this.postValidate
      }

      // 是否需要税率校验
      if (this.isProductionTax || this.userIpCountry === 'US') {
        step2 = !this.taxInfoSuccess
      }

      return step1 || step2
    },

    // 是否展示首充提示
    isShowFirstChargeTip() {
      return this.pack.package_type === 3 && this.userInfo.isFirst
    },

    // 商品最终价格
    totalPrice() {
      if (this.isProductionTax) {
        return this.taxInfo.taxed_price
      } else {
        return this.pack.package.final_amount
      }
    },
  },
  components: {
    Paypal,
    PrimerOther,
    Kakao,
    PayPay,
    UserInfo,
    ProductsItem,
    PostcodeInput,
  },
  created() {
    if (this.isProductionTax || this.userIpCountry === 'US') {
      this.getProductionTaxInfo = this.$utils.debounce(this.getProductionTaxInfo, 200)
      this.taxInfo = {
        real_amount: this.pack.package.final_amount,
        tax: '',
        taxed_price: this.pack.package.final_amount,
        currency: this.pay_info.currency,
        currency_label: this.pay_info.currency_label,
      }
    }

    // 进入直接进行 capture 验证, 不需要等待用户选择支付方式
    this.captureCheck()

    this.gatewatIndex(this.pack.support_gateway)
    this.payment_log = this.$parent.payment_log

    // 有更多付款方式时显示更多提示
    this.handleScroll = this.$utils.throttle(() => {
      this.showSeeMore = false
    }, 300)
  },
  mounted() {
    this.$nextTick(() => this.initSeeMore())
  },
  methods: {
    //调整支付顺序
    gatewatIndex(support_gateways) {
      try {
        if (window.ApplePaySession) {
          this.applepay_is = ApplePaySession.canMakePayments() == true ? true : false
        }
      } catch (error) {
        console.log('applepay_is error======', error)
      }

      const arr = []
      support_gateways = support_gateways.sort((a, b) => a - b)
      var nowDeviceType = this.$utils.getAppleDeviceType()
      const appleAndGooglePayways = []
      support_gateways.forEach((res) => {
        // 默认将adyen移动到前面
        if (res == this.$enum.GATEWAY_MAP.adyen || res == this.$enum.GATEWAY_MAP.primer) {
          arr.unshift(res)
        } else if (
          res == this.$enum.GATEWAY_MAP.apple_pay ||
          res == this.$enum.GATEWAY_MAP.google_pay
        ) {
          // 如果是 applepay 或者 googlepay 则需要根据设备类型在后续调整顺序，所以先缓存起来
          appleAndGooglePayways.push(res)
          arr.push(res)
        } else if (res == this.$enum.GATEWAY_MAP.kakao) {
          // kakao 支付金额小于 449000 才展示
          if (this.pack.package.final_amount <= 449000) {
            arr.push(res)
          }
        } else if (
          res == this.$enum.GATEWAY_MAP.paypal ||
          res == this.$enum.GATEWAY_MAP.paypal_paylater
        ) {
          this.paypalBtns.push(res)
          if (!arr.includes(0)) {
            arr.push(0)
          }
        } else {
          arr.push(res)
        }
      })

      // 根据设备类型调整 applepay 和 googlepay 的顺序
      appleAndGooglePayways.forEach((res) => {
        const index = arr.indexOf(res)
        if (index === -1) return
        if (res == this.$enum.GATEWAY_MAP.apple_pay) {
          if (this.applepay_is) {
            // 设备支持 applepay 则调整到前面
            if (nowDeviceType !== 'Other') {
              arr.splice(index, 1)
              arr.unshift(res)
            }
          } else {
            // 设备不支持 applepay 则移除
            arr.splice(index, 1)
          }
        } else if (res == this.$enum.GATEWAY_MAP.google_pay) {
          if (this.$utils.os === 'android' && googlePayFirstChannel.includes(this.channel)) {
            arr.splice(index, 1)
            arr.unshift(res)
          }
        }
      })

      // paypay 在 iOS 移动端优先级最高
      if (this.$utils.os === 'ios' && this.isMobile) {
        const paypayId = this.$enum.GATEWAY_MAP.paypay
        const paypalId = this.$enum.GATEWAY_MAP.paypal
        const paypayIdx = arr.indexOf(paypayId)
        const paypalIdx = arr.indexOf(paypalId)
        if (paypayIdx > -1 && paypalIdx > -1) {
          arr[paypayIdx] = paypalId
          arr[paypalIdx] = paypayId
        }
      } else {
        const paypayId = this.$enum.GATEWAY_MAP.paypay
        const paypayIdx = arr.indexOf(paypayId)
        if (paypayIdx > -1) {
          arr.splice(paypayIdx, 1)
          arr.unshift(paypayId)
        }
      }
      this.gateway = arr
    },
    setDefaultPayWay() {
      console.log('last_gateway======' + this.last_gateway)
      var lastpay = this.$enum.GATEWAY_MAP[this.last_gateway]
      if (lastpay != undefined && this.gateway.includes(lastpay)) {
        this.choosePay(lastpay)
      } else {
        this.choosePay(this.gateway[0])
      }
    },
    close() {
      //card支付按钮加载的时候不允许关闭
      if (this.pay_submitis != true) {
        this.$emit('close')
      }
    },
    choosePay(sty) {
      //card支付按钮加载的时候不允许切换
      var beforePayWay = this.$enum.PAY_WAY_MAP[this.choosePayWay]
      var nowsty = this.$enum.PAY_WAY_MAP[sty]
      //判断是否可以切换，如果是苹果或者谷歌按钮加载中，同时之前是谷歌或者苹果支付时则不允许切换
      if (
        (nowsty == 'google_pay' || nowsty == 'apple_pay') &&
        (beforePayWay == 'google_pay' || beforePayWay == 'apple_pay')
      ) {
        if (!this.apple_google_changeis) {
          return false
        }
      }

      if (this.pay_submitis != true) {
        this.choosePayWay = sty
        this.paysty = this.$enum.PAY_WAY_MAP[this.choosePayWay]

        if (this.isCardPay) {
          this.pay_btn_style = 'card'
        } else {
          this.pay_btn_style = 'render_loading'
          this.pay()
        }
      }
    },
    async pay() {
      if (this.isShowPostCode) {
        try {
          const { isValid, message } = await new Promise((resolve) => {
            this.$nextTick(() => {
              resolve(this.$refs.postcodeInput && this.$refs.postcodeInput.validatePostcode())
            })
          })
          if (!isValid) {
            this.postcodeErrortext = message
            return
          }
        } catch (error) {
          return
        }
      }
      var obj = this.pay_info
      obj.gateway = this.choosePayWay
      this.$set(this, 'payinfo', obj)
      //console.log(obj)

      //用于单据显示
      this.$parent.paysty = this.$enum.PAY_WAY_MAP[this.choosePayWay]

      // 直接拉起支付
      if (this.isCardPay) {
        //直接拉起也需要校验更新
        this.payinfo.request_id = this.captchaRequestId
        this.$parent.openPay()
      } else {
        //直接拉起也需要校验更新
        this.payinfo.request_id = this.captchaRequestId
        this.pay_btn_style = this.paysty
      }
    },
    //capture检测
    async captureCheck() {
      const curPackage = this.pack.package
      this.captureLoading = true
      try {
        const res = await checkCanPay({
          game_id: process.env.VUE_APP_GAME_ID,
        })

        if (res.data.code === 1) {
          if (this.isShowPostCode) {
            const localCode = this.$utils.customLocalStorage.getItem(
              `postcode_${this.userIpCountry}`
            )
            this.postcode = localCode || res.data.data.post_code
            if (this.postcode) {
              this.$nextTick(() => {
                this.handlePostcodeValidate(
                  this.$refs.postcodeInput && this.$refs.postcodeInput.validatePostcode()
                )
              })
            }
          }

          // 更新当前capture校验的request_id
          this.$parent.captchaRequestId = res.data.data.request_id
          this.captchaRequestId = res.data.data.request_id
          // 0:未开启 capture 1. 已开启 capture，未匹配规则 2. 已开启capture且匹配规则
          this.capture_status = res.data.data.capture_status

          // 1.captcha未开启——可以请求预订单
          // 2.开启captcha且未命中 captcha 规则——可以请求预订单
          // 3.开启captcha且命中 captcha 规则——弹验证
          // capture_status 状态 0:未开启 capture 1. 已开启 capture，未匹配规则 2. 已开启capture且匹配规则

          const taData = {
            payment_type: this.isCardPay ? 'card' : this.paysty,
            iap_product_id: curPackage.package_id,
            currency: this.currency,
            amount: curPackage.final_amount,
            index_id: res.data.data.request_id,
            operator_type: 4,
            result: this.capture_status + 1,
            ...getCallPaymentLimitTrackingProps(this.pack),
            ...(this.$store.state.app.fromInstalledWebApp
              ? { open_ui_old: 'desktop_shortcut' }
              : {}),
          }
          if (this.gameId === '20195') {
            taData.iap_name = this.pay_info.data_name || ''
            taData.pkg_id = this.pay_info.pack_id || ''
            taData.reward = this.pay_info.reward || ''
          }
          this.$ta.track('call_payment', taData)

          // 后台开启capture,且当前用户命中规则
          if (this.capture_status === 2) {
            // await this.$parent.getCaptchaCode()
            this.$parent.captchaVisible = true
          } else {
            this.$nextTick(() => this.setDefaultPayWay())
          }
        }
      } catch (error) {
        console.log(error)
        this.$rum.report(error)
      }
      this.captureLoading = false
    },
    //当capture校验完毕继续打开
    captchaSuccess(id) {
      this.captchaRequestId = id
      var obj = this.payinfo
      obj.request_id = id
      this.$set(this, 'payinfo', obj)

      this.setDefaultPayWay()
    },
    updateProviderOrderId(data) {
      this.$parent.updateProviderOrderId(data)
    },
    failpay(msg) {
      this.$parent.failpay(msg)
    },
    successpay(data) {
      this.$parent.successpay(data)
    },
    initSeeMore() {
      const orderContent = this.$refs.orderContent
      const legalTips = this.$refs.legalTips
      const payItem = this.$refs.payItem
      let payItemHeight = 0
      if (payItem) {
        if (payItem.offsetHeight) {
          payItemHeight = payItem.offsetHeight
        } else {
          payItemHeight = payItem[0] ? payItem[0].offsetHeight : 0
        }
      }
      if (!orderContent) return
      if (
        orderContent.offsetHeight <
        orderContent.scrollHeight - legalTips.offsetHeight - payItemHeight * 1.1
      ) {
        this.showSeeMore = true
      }
    },

    handlePostcodeValidate({ isValid, message }) {
      if (!isValid) {
        this.postcodeValidateError(message)
        return
      } else {
        // 触发校验的时候，说明已经变了
        // 每次校验成功后，重新渲染支付组件，重新生成订单
        this.postValidate = true
        this.postcodeErrortext = ''
        // 计税和美国邮编校验是独立的，需要单独处理
        if (this.isProductionTax || this.userIpCountry === 'US') {
          this.getProductionTaxInfo()
        } else {
          this.renderBuyBtn()
        }
      }
    },
    /**
     * 邮编校验失败包括 格式校验 和 合法性校验
     * @param message 错误信息
     */
    postcodeValidateError(message) {
      this.postcodeErrortext = message
      this.updatePayComponent = false
      this.postValidate = false
      this.taxInfoSuccess = false
      this.taxInfo = {
        real_amount: this.pack.package.final_amount,
        tax: '',
        taxed_price: this.pack.package.final_amount,
        currency: this.pack.package.currency,
        currency_label: this.pack.package.currency_label,
      }
    },
    // 渲染购买按钮
    renderBuyBtn(taxInfo) {
      // 更新 payinfo
      this.$emit('updatePayinfo', {
        post_code: this.postcode,
        ...taxInfo,
      })
      this.payinfo = {
        ...this.payinfo,
        post_code: this.postcode,
        ...taxInfo,
      }
      this.updatePayComponent = false
      this.$nextTick(() => {
        this.updatePayComponent = true
        if (!this.isCardPay) this.pay()
      })
    },

    // 获取税率信息
    getProductionTaxInfo() {
      if (!this.postValidate) return
      const params = {
        game_id: process.env.VUE_APP_GAME_ID,
        request_id: this.captchaRequestId,
        post_code: this.postcode,
        currency: this.currency,
        currency_label: this.pack.package.currency_label,
        product_id: this.pack.package.package_id,
      }
      this.taxInfoSuccess = false
      getProductionTax(params)
        .then((res) => {
          if (res.data.code === 1) {
            this.renderBuyBtn({
              real_amount: res.data.data.real_amount,
              tax: res.data.data.tax,
              taxed_price: res.data.data.taxed_price,
            })
            this.taxInfo = { ...this.taxInfo, ...res.data.data }
            this.taxInfoSuccess = true
            this.$store.commit('app/SET_PRODUCTION_TAX_EXPIRES', res.data.data.ts)
            this.$store.commit('SET_VALIDATE_POSTCODE_MAP', {
              postcode: this.postcode,
              isValid: true,
            })
          } else if (res.data.code === 101031011) {
            this.postcodeValidateError(this.$t('code.invalid'))
          } else if (res.data.code === 10103003) {
            this.$confirm({
              content: this.$t('game.shopUpdated'),
              hideClose: true,
              hideCancel: true,
              confirm: () => window.location.reload(true),
            })
          } else {
            this.postcodeValidateError(this.$t('tax.error'))
          }
        })
        .catch(() => {
          this.postcodeValidateError(this.$t('tax.error'))
        })
    },
  },
}
</script>

<style lang="less" scoped>
.order_confirm_con {
  z-index: 100;

  .main_content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 680px;
    height: auto;
    background: #fff;
    border-radius: 16px;
    padding: 0px 12px 12px;
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    /* 或 scroll */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    scrollbar-width: none;
    max-height: 100%;

    /* Firefox */
    .close_btn {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 12px;
      right: 12px;
      cursor: pointer;
      .bg-image('close');
    }

    .pay_title {
      font-size: 19px;
      color: #000000;
      line-height: 32px;
      margin: 8px auto;
      text-align: center;
    }

    .order-content {
      display: flex;
      align-items: stretch;
      justify-content: center;
      height: 536px;
      .flex-content {
        display: flex;
        flex-direction: column;
        overflow: hidden;
        &.pay_confirm_left {
          flex: 1;
        }
        &.pay_confirm_right {
          width: 290px;
          margin-left: 8px;
        }
      }

      .module_title {
        width: 100%;
        font-size: 13px;
        line-height: 14px;
        color: #62676b;
        margin-bottom: 8px;
      }
    }
    .order-total {
      .tax-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        line-height: 1;
        color: #62676b;
        & + .tax-item {
          margin-top: 8px;
        }
        .tax-item-title {
          display: flex;
          line-height: 12px;
          transform: translateZ(0);
          .question-icon {
            width: 12px;
            height: 12px;
            .bg-image('icon_question');
            margin-left: 4px;
          }
        }
        .number {
          color: #343a3f;
        }
        &.total {
          font-size: 18px;
          line-height: 1;
          .number {
            color: #ff8800;
          }
        }
      }
    }
    .module_con {
      width: 100%;
      background: rgba(242, 244, 248, 1);
      border-radius: 10px;
      border: 1px solid rgba(221, 225, 230, 1);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      box-sizing: border-box;
      padding: 8px 12px;
      overflow: hidden;
      & + .module_con {
        margin-top: 8px;
      }

      .module_content {
        flex: 1;
        overflow-y: auto;
        margin: 0 -12px;
        padding: 0 12px;
      }

      &.pack_info,
      &.pays_con {
        flex: 1;
      }

      &.pays_con {
        .pay_item {
          width: 100%;
          height: 46px;
          box-sizing: border-box;
          background: #ffffff;
          border-radius: 6px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          justify-content: space-between;
          cursor: pointer;
          border: 1px solid transparent;
          margin-bottom: 8px;
          font-size: 15px;
          color: #343a3f;
          padding-left: 10px;
          padding-right: 10px;
          position: relative;
          &:last-child {
            margin-bottom: 0;
          }

          &.active {
            border: 1px solid #ffaa00;
            background-color: #fff7e6;
          }

          .pay_icon {
            height: 20px;
            width: auto;
          }

          .pay_apple {
            height: 20px;
          }

          .pay_paypay {
            height: 32px;
          }

          .pay_paypal {
            height: 20px;
          }

          .pay_google {
            height: 32px;
          }

          .pay_choose_img {
            position: absolute;
            width: 22px;
            height: 22px;
            top: -1px;
            right: -1px;
          }
        }
      }

      &.pay-postcode {
        .txt {
          font-size: 13px;
          line-height: 14px;
          color: rgba(98, 103, 107, 1);
        }
        .red {
          color: rgba(223, 60, 60, 1);
        }
        .code-input-wrapper {
          background-color: #ffffff;
          border-radius: 8px;
          border: 1px solid rgba(135, 141, 150, 1);
          margin-top: 8px;
          padding: 14px 10px;
        }
      }
    }

    .pay_bottom {
      margin-top: 8px;
      display: block;
      padding: 12px;
      box-sizing: border-box;
      font-weight: 500;
      position: relative;
      flex-shrink: 0;
      .pay_bottom_total {
        height: 23px;
        font-size: 14px;
        color: #62676b;
        .pay_price {
          color: #ff8800;
        }
        .pay_price_big {
          font-size: 21px;
        }
      }
      .pay_bottom_tips {
        font-size: 12px;
        line-height: 1;
        font-weight: 400;
        margin-top: 4px;
        color: #62676b;
      }
    }

    .purchase-tips {
      font-size: 12px;
      line-height: 13px;
      vertical-align: middle;
      margin-top: 8px;
      color: #ff8800;
    }

    .pay_btn {
      width: 274px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 40px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      margin-top: 10px;
      left: -4px;
      bottom: -2px;
      .btn {
        width: 100%;
        height: 40px;
        position: absolute;
        top: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        background: #ffaa00;
        border-radius: 20px;
        cursor: pointer;
        &.disabled {
          // opacity: 0.7;
        }

        .btnload {
          width: 16px;
          height: 16px;
          animation: rotate 1s linear infinite;
          margin-right: 8px;
        }
      }

      .btntp {
        width: 100%;
        height: 40px;
        bottom: 0;
        border-radius: 20px;
        position: absolute;
        background-color: #000;
        overflow: hidden;
        &.paypal {
          background-color: transparent;
          height: unset;
          position: relative;
          &.isLoading::before {
            display: none;
          }
        }
        &.noPay {
          border-radius: 0;
          .payCardMain {
            border-radius: 0;
          }
        }
        &.isLoading::before {
          content: '';
          position: absolute;
          top: calc(50% - 10px);
          left: calc(50% - 10px);
          width: 20px;
          height: 20px;
          .bg-image('icon_loading');
          animation: rotate 1s linear infinite;
        }
      }

      .btn_active {
        background: rgba(255, 170, 0, 0.3);
      }

      .primerbtn {
        z-index: -1;
      }

      .showbtnp {
        z-index: 1;
      }
    }
    .see-more {
      display: none;
    }
    .legal-tips {
      color: #62676b;
      font-size: 13px;
      padding-bottom: 8px;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .kakaoitem {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
}

@keyframes shimmer {
  0% {
    left: -150px;
  }

  100% {
    left: 100%;
  }
}

@media (max-width: 1024px) {
  .order_confirm_con {
    .main_content {
      max-height: calc(100% - 50px);
      width: 100%;
      border-radius: 16px 16px 0 0;
      bottom: 0;
      top: unset;
      left: 0;
      transform: none;
      overflow: auto;

      .order-content {
        flex-direction: column;
        justify-content: flex-start;
        display: block;
        overflow: hidden;
        overflow-y: auto;
        height: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        .flex-content {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          &.pay_confirm_left {
            flex: none;
            display: block;
          }
          &.pay_confirm_right {
            width: 100%;
            flex: 1;
            overflow: visible;
            margin-top: 8px;
            margin-left: 0;
          }
        }
      }
      .module_con {
        border-color: transparent;
        .module_content {
          overflow: hidden;
          flex-shrink: 0;
          flex-grow: 1;
        }
        &.pays_con {
          .pay_item {
            border-color: rgba(221, 225, 230, 1);
          }
        }
      }

      .pay_bottom {
        position: relative;
        width: calc(100% + 24px);
        margin: 0 -12px;
        bottom: -12px;
        left: 0;
        right: 0;
        border: none;
        border-radius: 0;
        background-color: #ffffff;
        border-top: 1px solid rgba(221, 225, 230, 1);
        height: unset;
        flex-shrink: 0;
      }
      .purchase-tips {
        margin-top: 10px;
        &.purchase-tips-2 {
          margin-top: 0;
          margin-bottom: 10px;
        }
      }
      .pay_btn {
        position: relative;
        left: unset;
        bottom: unset;
        width: 100%;
        margin-top: 10px;
        .btn {
          position: unset;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          background: #ffaa00;
          border-radius: 19px;
          cursor: pointer;

          .btnload {
            width: 16px;
            height: 16px;
            animation: rotate 1s linear infinite;
            margin-right: 8px;
          }
        }

        .btn_active {
          background: rgba(255, 170, 0, 0.3);
        }

        .primerbtn {
          z-index: -1;
        }

        .showbtnp {
          z-index: 1;
        }
      }
      .see-more {
        display: block;
        padding: 6px;
        position: absolute;
        bottom: 160px;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 4px;
        max-width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        .text {
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          margin-right: 4px;
        }
        .see-more-btn {
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          .bg-image('icon_more_down');
        }
      }
      .legal-tips {
        font-size: 12px;
        padding-top: 12px;
        padding: 12px 4px 0;
        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
